<form #form="ngForm" class="app-grid">
    <mat-form-field>
        <mat-label>{{
            'performance.goal-show.goalUpdateModal.formFields.progressDetails.label' | translate
        }}</mat-label>
        <input
            matInput
            type="text"
            name="comment"
            [(ngModel)]="update.comment"
            placeholder="{{
                'performance.goal-show.goalUpdateModal.formFields.progressDetails.placeholder' | translate
            }}"
        />
    </mat-form-field>

    <ng-container *ngIf="['dollar', 'percent', 'number'].includes(goal.metricType)" class="fields">
        <div class="columns-12 align-left">
            <mat-label>{{
                'performance.goal-show.goalUpdateModal.formFields.selectAction.label' | translate
            }}</mat-label>

            <mat-radio-group class="vertical" name="actionType" [ngModel]="actionType">
                <mat-radio-button value="add" (click)="updateIncrementToggle()">
                    {{ 'performance.goal-show.goalUpdateModal.formFields.selectAction.addAmountOption' | translate }}
                </mat-radio-button>
                <mat-radio-button value="reset" (click)="updateTotalToggle()">
                    {{ 'performance.goal-show.goalUpdateModal.formFields.selectAction.resetTotalOption' | translate }}
                </mat-radio-button>
            </mat-radio-group>
        </div>

        <!-- FIXME - util classes -->
        <mat-form-field class="columns-6 small-columns-12" style="margin-top: 16px">
            <mat-label>{{ 'performance.goal-show.goalUpdateModal.formFields.amount.label' | translate }}</mat-label>
            <span matSuffix>{{ suffixSymbol }}</span>
            <input
                matInput
                type="number"
                name="metric_value"
                [(ngModel)]="update.metricValue"
                placeholder="{{ 'performance.goal-show.goalUpdateModal.formFields.amount.placeholder' | translate }}"
            />
        </mat-form-field>
    </ng-container>

    <!-- FIXME - util classes -->
    <mat-checkbox
        *ngIf="goal.metricType === 'binary'"
        style="margin-top: 16px"
        class="align-left"
        name="metric_value"
        [(ngModel)]="update.metricValue"
        >{{ 'performance.goal-show.goalUpdateModal.formFields.markGoalComplete' | translate }}</mat-checkbox
    >

    <ng-container *ngIf="goal.metricType === 'milestones'" style="text-align: left">
        <mat-label class="align-left">
            {{ 'performance.goal-show.goalUpdateModal.formFields.milestones' | translate }}
        </mat-label>
        <mat-checkbox
            class="columns-12 align-left"
            *ngFor="let milestone of goal.metricMilestones; let index = index"
            name="metric_value_{{ index }}"
            [(ngModel)]="update.metricMilestones[index]['complete']"
            >{{ milestone.label }} - {{ milestone.description }}
        </mat-checkbox>
    </ng-container>

    <!-- FIXME - util classes -->
    <div class="columns-12 align-left" style="margin-top: 16px">
        <mat-label>
            {{ 'performance.goal-show.goalUpdateModal.formFields.mileStoneStatus.label' | translate }}
        </mat-label>
        <mat-radio-group name="progressStatus" [(ngModel)]="progressStatus" class="vertical">
            <mat-radio-button [value]="progressStatuses.behind" (click)="updateToggleOffTrack()">{{
                'performance.goal-show.goalUpdateModal.formFields.mileStoneStatus.behindOption' | translate
            }}</mat-radio-button>
            <mat-radio-button [value]="progressStatuses.onTrack" (click)="updateProgressingTrack()">{{
                'performance.goal-show.goalUpdateModal.formFields.mileStoneStatus.onTrackOption' | translate
            }}</mat-radio-button>
            <mat-radio-button [value]="progressStatuses.aheadOfSchedule" (click)="updateToggleOnTrack()">{{
                'performance.goal-show.goalUpdateModal.formFields.mileStoneStatus.aheadOfScheduleOption' | translate
            }}</mat-radio-button>
        </mat-radio-group>
    </div>
</form>
